import React,{useState, useEffect, useRef, useContext} from 'react';
import {Card,Row,Col, Modal, Form, Button, Badge, Alert, FormControl, Spinner} from 'react-bootstrap';
import _, { isUndefined } from 'lodash';
import {Uploader,RTEditor} from './../../components';
import Utils from './../../Utils';
import axios from 'axios';
import UserContext from './../../contexts/UserContext';

const CustomTemplateList = (props) => {

  const { getPkgSize,getAvailableSize} = useContext(UserContext);
  const [audio, setAudio] = useState(_.get(props, 'data.audio', "false"))
  const [title, setTitle] = useState('');
  const titleRef = useRef(0);
  const [tplConfig,setConfig] = useState(false);  
  const [errMsg,setErrMsg] = useState('');
  const tempTitle = useRef(0);
  const [uploading, setUploading] = useState(false);
  const imagesize_in_mb =  _.get(process.env,'REACT_APP_MAX_IMAGE_SIZE',1);
  const videosize_in_mb =  _.get(process.env,'REACT_APP_MAX_VIDEO_SIZE',50);
  const scormsize_in_mb = _.get(process.env,'REACT_APP_MAX_SCORM_SIZE',50);

  useEffect(() => {
    axios.get(process.env.PUBLIC_URL + '/images/templates/tplConfig.json',Utils.apiHeaders()).then(res => {
      setConfig(res.data);
    }).catch(err => console.log(err));
  },[]);

  const numOfSlides = 19;

  const categories = {
    "all": [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19],
    "text": [1,2,3,4,5,6,8,9,16,17,18,19],
    "image": [1,4,5],
    "keypoints": [7,13,14],
    "video": [10],
    "accordion": [12,15], 
    "timeline": [11,12]

  };

  const isEdit = () => {
    return _.get(props,'mode',0) > 0;
  };

  const [editor, setEditor] = useState(false);
  const [slide, setSlide] = useState(_.get(props,'data',{}));  
  const [slideNum, setSlideNum] = useState(_.get(props,'data.template',0)); 
  const [catSel, setCatSel] = useState(["all"]);
  const [slideTitle, setSlideTitle] = useState(_.get(props, 'data.title', ''));
  
  const selectCategory = (key) => (e)  => {
    let tmp = [];
    tmp.push(key);
    // if(tmp.includes(key)){
    //   tmp = tmp.filter(t => t!==key); // remove if it already exists
    // }else{
    //   tmp.push(key);
    // }
    setCatSel(tmp);
  }

  const saveTitle = (e) => {    
    setTitle(e.currentTarget.value)
  }

  const getTemplates = () => {
    let temp = (new Array(numOfSlides)).fill(0);
    let temp2 = [];
    temp = temp.map((val,idx) => idx + 1);

    catSel.forEach(c => {
      temp2.push(...categories[c]);
    });
    
    if(_.isEmpty(catSel)){
      return temp;
    }
    else{
      return _.uniq(temp2);
    }
  }

  const showTemplate = (num) => (e) => {
    setSlideNum(num);
  }

  const initEditor = (e) => {
    const ele = e.currentTarget;    
    e.stopPropagation(); //== stop bubble click
    setEditor(ele);
  } 

  const getFrameEditorElements = () => {    
    if(document.getElementsByClassName('ct-iframe').length > 0){
      const iframe = document.getElementsByClassName('ct-iframe')[0].contentWindow.document;      
      return [...iframe.querySelectorAll('[editname]'),...iframe.querySelectorAll('.popBtn')];
    }else{      
      return [];
    }
  }

  const initFrame = () => {
    const eles = getFrameEditorElements();    
    var editname = '';
    for(var idx = 0 ; idx < eles.length ; idx ++){
      if(eles[idx].className.includes('popBtn')){
        eles[idx].addEventListener('click',preInitEditor); //=== if inside a popup then initiate editor on display
      }else{
        editname = eles[idx].getAttribute('editname');
        if(_.get(tplConfig,`${slideNum-1}.${editname}`,false)){
          if(_.get(tplConfig,`${slideNum-1}.${editname}.removable`,false)){
            const removeEle = document.createElement('img');
            removeEle.setAttribute('src','../minus_circle_icon.png');
            removeEle.setAttribute('class','remove');
            eles[idx].parentNode.insertBefore(removeEle,eles[idx].nextSibling);
            removeEle.addEventListener('click',function(){              
              this.previousSibling.remove();
              this.remove();
            });
          }else{
            eles[idx].setAttribute('editas',tplConfig[slideNum-1][editname].type);
            eles[idx].addEventListener('click',initEditor);        
          }
        }
      }
    }
    parseEditor();
  }

  const preInitEditor = (e) => {
    const iframe = document.getElementsByClassName('ct-iframe')[0].contentWindow.document;
    iframe.querySelectorAll(`.popupWrap .popInside [editname]`).forEach(e => e.addEventListener('click', initEditor));
  }

  const parseEditor = () => {
    const eles = getFrameEditorElements();
    var val='';
    if(slide['template'] === slideNum){
      for(var idx = 0 ; idx < eles.length ; idx ++){     
        val = _.get(slide,eles[idx].getAttribute('editname'),'');
        if(val!==''){
          if(eles[idx].getAttribute('editas')==='image'){
            eles[idx].setAttribute('src',Utils.apiUrl(`image?f=${val}&nothumb=1`));
          }else if(eles[idx].getAttribute('editas')==='video'){
            eles[idx].setAttribute('src',Utils.apiUrl(`file?f=${val}`));
          }else{
            console.log(val);
            eles[idx].innerHTML = val.replace(/\n/g,"<br />");
          }
        }
      }
    }
  }

  useEffect(parseEditor,[slide]); // on change of slide attributes

  useEffect(() => {    
    window.setTimeout(() => {
      if(editor!==false){
        if(editor.getAttribute('editas')!=='image'){
          if(document.getElementById('editorFrm').field !== undefined){
            document.getElementById('editorFrm').field.focus();// set focus to editor element
          }
        }
      }
    },500);
  },[editor]);

  const handleTitleChange = (e) => {
    e.preventDefault();
    setSlideTitle(e.currentTarget.value);
    
  }

  const saveSlide = () => {   
  
    if(slideTitle === ''){
      window.alert("Please enter title");      
      return false;
    }
    let html = document.getElementsByClassName('ct-iframe')[0].contentWindow.document.getElementsByTagName('html')[0];
    html =  html.getElementsByTagName('body')[0].innerHTML;
    
    props.onSlideSave({...slide, template: _.get(slide,'template',slideNum), title: slideTitle, html: html},'Template',isEdit());
    setSlideNum(0);
    
  }


  const showTemplateModal = () => {
    return <Modal
        show={slideNum > 0}
        onHide={() => setSlideNum(0)}
        backdrop="static"
        keyboard={false}
        size="xl"
      >
      <Modal.Header closeButton className="slInsPop">        
      </Modal.Header>

      {showIframePortion()}
        
    </Modal> 
  }

  const showIframePortion = () => {
    return <>
      <Row className="justify-content-center"> 
          <Col lg={2}>
              <label htmlFor="slideTitle"><p className="pt-3"><strong>Slide Title :</strong></p> </label>
          </Col> 
          <Col lg={7}>
            <FormControl  className="mt-2 py-2 w-100 input-text" 
                      onChange={e => handleTitleChange(e)} 
                      name="slideTitle" type="input" 
                      defaultValue={slide.title}
                      placeholder="Enter title for template">
            </FormControl> 
          </Col>
      </Row>                    
      <Modal.Body>        
        <iframe onLoad={initFrame}
                title="TemplateSlide" 
                className="w-100 ct-iframe"                 
                style={{height: '600px', border: 'none'}} 
                src={`${process.env.PUBLIC_URL}/images/templates/slide-${slideNum}.html`}>                
        </iframe>
        <Row>
          <Col sm={1}>

          </Col>
          <Col sm={11}>

          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button className="active px-5 py-2" onClick={saveSlide}>Save</Button>
      </Modal.Footer>    
    </>
  }

  const saveAttribute = (e) => {
    const frm = e.currentTarget;
    e.preventDefault();
    const type = editor.getAttribute('editas');
    if(type !== 'video'){
      saveAttributeNow(frm.field.value);
    }   
  }

  const saveAttributeNow = (attr,status) => {
    if(status==='error_file_size'){
      setErrMsg(`You have uploaded ${(attr.meta.size/1024/1024).toFixed(1)} MB file, however, 
      the acceptable maximum file size is ${getAvailableSize(videosize_in_mb)} MB. Try again with an acceptable sized file.`);
    }else{ 
      let file_size = 0;
      if(status !== undefined){
        file_size = (status.size/1024/1024).toFixed(1);
      }
      let tot_size = parseFloat(file_size) + getPkgSize();
      if(tot_size > scormsize_in_mb){
        setErrMsg(`Total SCROM size allowed is ${getAvailableSize(videosize_in_mb)} MB,You have used ${getPkgSize()} MB.`);
        return;
      }else{      
              setErrMsg('');
              const sld = {...slide,size: file_size};
              sld['template'] = slideNum;
              sld[editor.getAttribute('editname')] = attr;
              setSlide({...sld});
              setEditor(false);
          }
    }
  }
  


  const startUploading = (attr, status) => {
    if(status=='rejected_file_type'){
      setUploading(false);
      window.alert('Please follow instruction to upload acceptable file');      
    }
    else{
      setUploading('Please wait... We are processing your file...');
    }
  }

  const onUploadVideo = (attr,meta) => { 
    if(meta === 'error_file_size'){
      setErrMsg(`You have uploaded ${(attr.meta.size/1024/1024).toFixed(1)} MB file, however, 
      the acceptable maximum file size is ${getAvailableSize(videosize_in_mb)} MB. Try again with an acceptable sized file.`);
      window.setTimeout(function(){
        setErrMsg('');
        setUploading(false);
      },5000)
    }else{
      let file_size = (meta.size/1024/1024).toFixed(1);
      let tot_size = parseInt(file_size) + getPkgSize();
      if(tot_size > scormsize_in_mb){
        setErrMsg(`Total SCROM size allowed is ${scormsize_in_mb} MB,You have used ${getPkgSize()} MB.`);
        return;
      }else{ 
        setErrMsg('');
        const sld = {...slide,size: file_size};
        sld['template'] = slideNum;
        sld[editor.getAttribute('editname')] = attr;
        setSlide({...sld});
        setEditor(false);    
        setUploading(false); 
      }
    }
  }

  const showEditorModal = () => {
    const key = editor.getAttribute('editname');
    const type = editor.getAttribute('editas');
    return <Modal
        show={editor !== false}
        onHide={() => {setEditor(false);setErrMsg('');}}
        backdrop="static"
        keyboard={false}
        size='xl'
      >
      <Form id="editorFrm" onSubmit={saveAttribute}>
        <Modal.Header closeButton>
          <Modal.Title>
            Edit {key}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {type==='text' && <Form.Control name="field" type={type} defaultValue={_.get(slide,key,'')} />}
          {type==='textarea' && <RTEditor name="field" as={type} value={_.get(slide,key,'')} />}
          {type==='image' && <div>
            <Uploader 
            instructions={`To upload Image file (max allowed ${getAvailableSize(imagesize_in_mb)} MB), click here or drag-drop the Image here`}
            accept="image/*" 
            maxSizeBytes={getAvailableSize(imagesize_in_mb)*1024*1024} 
            uploadUrl={Utils.apiUrl('saveupload')} 
            onUpload={saveAttributeNow} />
          </div>}
          {type==='video' && <div>
            {(uploading && errMsg === '' ) && <p className="text-center">{ uploading} <Spinner animation="border" variant="dark"  /></p>}
            <Uploader 
            instructions={`To upload Video file (max allowed ${getAvailableSize(videosize_in_mb)} MB), click here or drag-drop your video here`}
            accept="video/*" 
            maxSizeBytes={getAvailableSize(videosize_in_mb)*1024*1024} 
            uploadUrl={Utils.apiUrl('saveupload')} 
            onUpload={onUploadVideo} 
            onSubmit={startUploading}/>
          </div>}
          {errMsg !== '' && (type==='image' || type==='video') && <>
          <Row className="mx-3 mb-4">    <Col className="text-center"><Alert variant="danger" className="p-3"><i className="fa fa-exclamation-circle" />  {errMsg} </Alert> </Col></Row>
          </>}
        </Modal.Body>

        <Modal.Footer>
          {type!=='image' && <button type="submit" className="btn btn-primary">Save</button>}
        </Modal.Footer>
      </Form>  
    </Modal> 
  }

  const renderList = () => {
    return <>
    <div className="cusTempListWrap popcotentpad">
      
      <div className="listtype">
        {Object.keys(categories).map(key => <Badge variant={catSel.includes(key) ? 'dark' : 'light'} onClick={selectCategory(key)}  className="mx-1 p-2" key={key}>#{key}</Badge>)}
      </div>
      <Row>
        {getTemplates().length === 0 && <Col sm={12}><Alert variant="info" className="m-2 text-center p-2">No Templates available!</Alert></Col>}
        {getTemplates().map(v => <Col sm={3} key={v}>
          <Card className="m-2 template-slide" onClick={showTemplate(v)}>
            <Card.Body className="p-1">
              <img src={`${process.env.PUBLIC_URL}/images/template-thumbnails/slide-${v}.jpg`} className="img-fluid" alt=""/>
            </Card.Body>
          </Card>
        </Col>)}
      </Row>
      </div>
    </>;
  }

  return <>
    {!isEdit() && renderList()}
    {slideNum > 0 && <>
      {!isEdit() && showTemplateModal()}
      {isEdit() && showIframePortion()}
    </>}
    {editor !== false && showEditorModal()}
    <script src="https://cdnjs.cloudflare.com/ajax/libs/html2canvas/0.5.0-beta4/html2canvas.min.js" integrity="sha512-OqcrADJLG261FZjar4Z6c4CfLqd861A3yPNMb+vRQ2JwzFT49WT4lozrh3bcKxHxtDTgNiqgYbEUStzvZQRfgQ==" crossOrigin="anonymous" referrerPolicy="no-referrer"></script>
  </>;
}

export default CustomTemplateList;